if (!customElements.get('quick-add-modal-pack-builder')) {
  customElements.define(
    'quick-add-modal-pack-builder',
    class QuickAddModalPackBuilder extends ModalDialog {
      constructor() {
        super();
        this.modalContent = this.querySelector('[id^="QuickAddInfo-"]');

        this.addEventListener('product-info:loaded', ({ target }) => {
          target.addPreProcessCallback(this.preprocessHTML.bind(this));
        });
      }

      hide(preventFocus = false) {
        const cartNotification = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        if (cartNotification) cartNotification.setActiveElement(this.openedBy);
        this.modalContent.innerHTML = '';
        const productModal = document.querySelector('[id^="ProductModal-quickadd-"]');
        productModal.remove();
        if (preventFocus) this.openedBy = null;
        super.hide();
      }

      show(opener) {
        opener.setAttribute('aria-disabled', true);
        opener.classList.add('loading');
        opener.querySelector('.loading__spinner').classList.remove('hidden');

        fetch(opener.getAttribute('data-product-url'))
          .then((response) => response.text())
          .then((responseText) => {
            const responseHTML = new DOMParser().parseFromString(responseText, 'text/html');
            const productElement = responseHTML.querySelector('product-info');

            this.preprocessHTML(productElement);
            HTMLUpdateUtility.setInnerHTML(this.modalContent, productElement.outerHTML);

            if (window.Shopify && Shopify.PaymentButton) {
              Shopify.PaymentButton.init();
            }
            if (window.ProductModel) window.ProductModel.loadShopifyXR();

            super.show(opener);

            // S'assurer que l'écouteur est bien attaché après tout le DOM a été mis à jour
            this.replaceForm(this.modalContent);
          })
          .finally(() => {
            opener.removeAttribute('aria-disabled');
            opener.classList.remove('loading');
            opener.querySelector('.loading__spinner').classList.add('hidden');
          });
      }

      preprocessHTML(productElement) {
        productElement.classList.forEach((classApplied) => {
          if (classApplied.startsWith('color-') || classApplied === 'gradient')
            this.modalContent.classList.add(classApplied);
        });
        this.preventDuplicatedIDs(productElement);
        this.removeDOMElements(productElement);
        this.removeGalleryListSemantic(productElement);
        this.updateImageSizes(productElement);
        this.preventVariantURLSwitching(productElement);
      }

      preventVariantURLSwitching(productElement) {
        productElement.setAttribute('data-update-url', 'false');
      }

      replaceForm(productElement) {
        const form = productElement.querySelector('product-form');
        const productInfoContainer = productElement.querySelector('.product__info-container');
        const packBuilder = document.querySelector('deployer-pack-builder');
        if (form) {
          form.style.display = 'none';
          const atcButton = document.createElement('button');
          atcButton.classList.add(
            'quick-add',
            'button',
            'button--full-width',
            'button--primary',
            'quick-add-pack-builder',
            'quick-add-pack-builder--add'
          );
          atcButton.innerHTML = `<span class="quick-add-pack-builder--text">${
            productElement.querySelector('.product-form__submit').innerHTML
          }</span>`;
          atcButton.addEventListener('click', async (e) => {
            try {
              const variantId = productElement.querySelector('product-form input[name="id"]').value;
              // Utilise await pour attendre le résultat de getVariantData
              const variantData = await packBuilder.getVariantData(this.dataset.handle, variantId);
              packBuilder.dispatchVariantFromQuickAdd(variantData);
              // close the modal
              this.hide();
            } catch (error) {
              console.error('Erreur lors de la récupération de variantData:', error);
            }
          });

          // Injection en dessous de l'élément approprié
          const iconWithTextVertical = productInfoContainer.querySelector('.icon-with-text--vertical');
          const variantPicker = productInfoContainer.querySelector('variant-selects');
          if (iconWithTextVertical && !variantPicker) {
            iconWithTextVertical.insertAdjacentElement('afterend', atcButton);
          } else if (variantPicker) {
            variantPicker.insertAdjacentElement('afterend', atcButton);
          } else {
            productInfoContainer.appendChild(atcButton); // Dernier recours : append à la fin du container
          }
        }
      }

      removeDOMElements(productElement) {
        const pickupAvailability = productElement.querySelector('pickup-availability');
        if (pickupAvailability) pickupAvailability.remove();

        const productModal = productElement.querySelector('.product-popup-modal__opener');
        if (productModal) productModal.remove();

        const modalDialog = productElement.querySelectorAll('modal-dialog');
        if (modalDialog) modalDialog.forEach((modal) => modal.remove());

        /*         const deliveryInfo = productElement.querySelector('.delivery-infos_container');
        if (deliveryInfo) deliveryInfo.remove(); */

        const sliderCrossSells = productElement.querySelector('.slider-cross-sells');
        if (sliderCrossSells) sliderCrossSells.remove();
        /* 
        const accordions = productElement.querySelectorAll('.product__accordion');
        if (accordions) accordions.forEach((accordion) => accordion.remove()); */

        const fakeColorSwatches = productElement.querySelector('.collection-links--container');
        if (fakeColorSwatches) fakeColorSwatches.remove();

        const fakeVariants = productElement.querySelectorAll('.component__fake-variants');
        if (fakeVariants.length > 0) fakeVariants.forEach((fakeVariant) => fakeVariant.remove());
      }

      preventDuplicatedIDs(productElement) {
        const sectionId = productElement.dataset.section;

        const oldId = sectionId;
        const newId = `quickadd-${sectionId}`;
        productElement.innerHTML = productElement.innerHTML.replaceAll(oldId, newId);
        Array.from(productElement.attributes).forEach((attribute) => {
          if (attribute.value.includes(oldId)) {
            productElement.setAttribute(attribute.name, attribute.value.replace(oldId, newId));
          }
        });

        productElement.dataset.originalSection = sectionId;
      }

      removeGalleryListSemantic(productElement) {
        const galleryList = productElement.querySelector('[id^="Slider-Gallery"]');
        if (!galleryList) return;

        galleryList.setAttribute('role', 'presentation');
        galleryList.querySelectorAll('[id^="Slide-"]').forEach((li) => li.setAttribute('role', 'presentation'));
      }

      updateImageSizes(productElement) {
        const product = productElement.querySelector('.product');
        const desktopColumns = product?.classList.contains('product--columns');
        if (!desktopColumns) return;

        const mediaImages = product.querySelectorAll('.product__media img');
        if (!mediaImages.length) return;

        let mediaImageSizes =
          '(min-width: 1000px) 715px, (min-width: 750px) calc((100vw - 11.5rem) / 2), calc(100vw - 4rem)';

        if (product.classList.contains('product--medium')) {
          mediaImageSizes = mediaImageSizes.replace('715px', '605px');
        } else if (product.classList.contains('product--small')) {
          mediaImageSizes = mediaImageSizes.replace('715px', '495px');
        }

        mediaImages.forEach((img) => img.setAttribute('sizes', mediaImageSizes));
      }
    }
  );
}
